import { render, staticRenderFns } from "./AlertStatus.vue?vue&type=template&id=c1a60e7c&"
import script from "./AlertStatus.vue?vue&type=script&lang=js&"
export * from "./AlertStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports